// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yvAP3k{overflow:hidden}.yvAP3k svg{height:100%;width:auto}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `yvAP3k`
};
export default ___CSS_LOADER_EXPORT___;
